import { render, staticRenderFns } from "./oneDetails.vue?vue&type=template&id=d8247466&scoped=true&"
import script from "./oneDetails.vue?vue&type=script&lang=js&"
export * from "./oneDetails.vue?vue&type=script&lang=js&"
import style0 from "./oneDetails.vue?vue&type=style&index=0&id=d8247466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8247466",
  null
  
)

export default component.exports